<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="6" v-for="(o, index) in list" :key="index" style="padding-top: 20px">
        <el-card :body-style="{ padding: '0px' }" style="height: 235px;">
          <img :src="o.imgSrc" class="image" style="height: 160px">
          <div style="padding: 14px;">
            <span style="font-weight:bold; cursor:pointer;"  @click="rt(o.rt)">{{ o.name }}</span>
            <div class="bottom clearfix" style="font-size: 14px">
<!--              <div>{{ o.content }}</div>-->
<!--              <div><a style="color: rgb(124, 185, 186); cursor:pointer;" @click="rt(o.rt)">查看更多</a></div>-->
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "NewsPlugin",
  data() {
    return {
      list: [
        {name: '踏青 | 新中式、下午茶，武汉樱花季新玩法get', content:"每年3-4月的大好时段中，武汉，就会因为樱花季的如约而至......",imgSrc: require('../assets/images/news/new1.png'),rt:"https://mp.weixin.qq.com/s/3pb6MJ97D09WRlq7XwbUdw" },
        {name: '宋风 | 陌上这些“雅”语暗号，你懂几个？',content:"陌上，宋风美学酒店，将宋式建筑风格融入到酒店的同时.....", imgSrc: require('../assets/images/news/new2.png'),rt:"https://mp.weixin.qq.com/s/JwmQRZm1TE4JuvHbyVm3tg" },
        {name: '这个传奇家族，凭什么绵延千年，名人辈出？',content:"千年前芸芸众生里，一个人鲜衣怒马，浪漫终身。两个人.....", imgSrc: require('../assets/images/news/new3.png'),rt:"https://mp.weixin.qq.com/s/Om45VkiRL81wrLlr1-LGlQ" },
        {name: '放心来，安心住 | 陌上酒店消杀工作持续升级',content:"“疫情就是命令，防控就是责任。”目前疫情期间，人员大.....", imgSrc: require('../assets/images/news/new4.png'),rt:"https://mp.weixin.qq.com/s/gFGlq9YcA_5hOK6GBE4T1g" },
        {name: '四店齐开 | 最美南太行，正宗胡辣汤……陌上的这些新店很有料',content:"2022年开春，陌上酒店迎来了一大波新酒店的开业，又值大.....", imgSrc: require('../assets/images/news/new5.png'),rt:"https://mp.weixin.qq.com/s/A2u596emI_eROX47qIaCRQ" },
      ]
    }
  },
  methods: {
    rt(rt) {
      let nw = location = rt;
      //let nw = this.$router.resolve({path: rt})
      window.open(nw.href,'_blank')
    }
  }
}
</script>

<style scoped>
  .image {
    width: 100%;
    display: block;
  }
</style>
